import { defineComponent as _defineComponent } from 'vue'
import { Button, Icon, Modal, Typo } from '@travelata-libs/ui-kit';
  import { useViewport } from '@travelata-libs/utils';
  import { ref } from 'vue';
  import Tooltip from '@ve/components/tooltip/Tooltip.vue';
  import { PROVIDERS_MODAL_Z_INDEX, TRUST_NOTE_DESCRIPTION, TRUST_NOTE_TITLE } from '../config';

  interface ProvidersTrustNoteEmits {
    (e: 'tooltip-open'): void;
    (e: 'tooltip-close'): void;
  }

  
export default /*#__PURE__*/_defineComponent({
  __name: 'ProvidersTrustNote',
  emits: ["tooltip-open", "tooltip-close"],
  setup(__props, { emit }: { emit: ({
    (e: 'tooltip-open'): void;
    (e: 'tooltip-close'): void;
  }), expose: any, slots: any, attrs: any }) {

  

  const { isMobile } = useViewport();

  const isModalOpen = ref<boolean>(false);

  const openTooltip = (): void => {
    isModalOpen.value = true;
    emit('tooltip-open');
  };

  const closeTooltip = (): void => {
    isModalOpen.value = false;
    emit('tooltip-close');
  };

return { __sfc: true,emit, isMobile, isModalOpen, openTooltip, closeTooltip, Button, Icon, Modal, Typo, Tooltip, PROVIDERS_MODAL_Z_INDEX, TRUST_NOTE_DESCRIPTION, TRUST_NOTE_TITLE }
}

})